import { render, staticRenderFns } from "./PackagesReceivedModal.vue?vue&type=template&id=7654a3f8&scoped=true&"
import script from "./PackagesReceivedModal.vue?vue&type=script&lang=js&"
export * from "./PackagesReceivedModal.vue?vue&type=script&lang=js&"
import style0 from "./PackagesReceivedModal.vue?vue&type=style&index=0&id=7654a3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654a3f8",
  null
  
)

export default component.exports